module.exports = __webpack_public_path__ + "img/08影音.3d17ad7d.jpg";